import { View } from 'backbone.marionette';
import templates from './templates';
import './index.styl';

export default class LeagueRowView extends View {
	get template() {
		const
			type_page = this.getOption('type_page'),
			type_league = this.model.get('type'),
			is_open = (type_league === 'open');

		let result;

		switch (type_page) {
			case 'join':
				result = is_open ? templates.joinOpen : templates.joinH2H;
				break;
			case 'regenerate':
				result = is_open ? templates.regenerateOpen : templates.regenerateH2H;
				break;
			default :
				result =  is_open ? templates.showOpen : templates.showH2H;
		}

		return result;
	}

	get className() {
		return 'table-row-item';
	}

	ui() {
		return {};
	}

	events() {
		return {};
	}

	initialize() {
		const {
			user, rounds, players, type_page
		} = this.options;

		if (this.model.get('opponent')) {
			this.setFixture()
		}

		const current_round = this.model.get('current_round');
		const matches = (current_round && current_round.matches) || [];

		const is_league_playing = this.model.get('status') === 'playing';
		const has_playing_matches = matches.some(match => match.status === 'playing');
		const is_playing = has_playing_matches && is_league_playing;

		this.model
			.set( {
				my_team: user.toJSON(),
				rounds: rounds.toJSON(),
				rounds_collection: rounds,
				players: players,
				is_playing
			} )
			.checkAccessToLeague( user.id )
			.checkIsPossibleLeave()
			.setAvatar()
			.updateUserName()
			.isStarted()
			.checkAccessToSettings();
		if (type_page !== 'regenerate') {
			this.model.setMyTeamsProjScores();
		}

	}

	setFixture() {
		const { avatar_url, team_name } = this.options.user.attributes,
			{ lineup } = this.options.user_team.attributes,
			{ opponent, team_points, team_id } = this.model.attributes,
			user_obj = {
				avatar_url,
				team_name,
				score: team_points,
				team_id,
				lineup
			},
			opponent_obj = {
				avatar_url: `${process.env.AVATARS_PATH}${opponent.user_id}.png`,
				...opponent
			},
			fixture = {
				away: {
					away: { ...user_obj },
					home: { ...opponent_obj }
				},
				home: {
					home: { ...user_obj },
					away: { ...opponent_obj }
				}
			}[opponent.side]
		;

		this.model.set({
			...fixture
		});
	}

}